var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-file",on:{"click":function($event){return _vm.setAttachmentFilesModalProps({ module: _vm.module })}}},[_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn",attrs:{"title":"Anexar arquivo"}},[_c('Paperclip')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }